import * as d3 from 'd3'
export default {

  methods: {

    call_Link(selection, phase) {

      if(phase == 'Commissioning') return 

      let self = this
      selection
      .attr('cursor', 'pointer')
      .on('mouseover', function() {
        d3.select(this).transition().duration(50).style('opacity', .5)
        self.reflash(phase)
      })
      .on('mouseout', function() {
        d3.select(this).transition().duration(50).style('opacity', 1)
      })
      .on('click', () => {
        
      })
    },

    reflash(phase) {
      
      this.currnet.phase = phase

      d3.select(`#AREA_MAIN_${this.localId}`).text(phase)
      d3.select(`#AREA_SUB_${this.localId}`).attr('x', this.getNode(`#AREA_MAIN_${this.localId}`) + 5)
      d3.selectAll(`.PHASE`).text(phase)

      this.area.cols.forEach(col=> {
        col.plan   = this.areaData.find(f=> f.PHASE == this.currnet.phase && f.AREA == col.name).PLAN
        col.actual = this.areaData.find(f=> f.PHASE == this.currnet.phase && f.AREA == col.name).ACTUAL
        col.delta  = this.areaData.find(f=> f.PHASE == this.currnet.phase && f.AREA == col.name).DELTA
        if(col.actual<0.1) col.actual = 0.00001

        let barLen = (this.area.barLen/100) * col.actual
        d3.select(`#BAR_${col.name}_${this.localId}`).transition().duration(500).attr('width', barLen)

        d3.select(`#DELTA_${col.name}_${this.localId}`).attr('fill', this.gmx_deltaValue(col.delta))

        this.gmx_textTween(`#ACT_${col.name}_${this.localId}`, col.actual, 500, '%', null, null, null, null, 1)
        this.gmx_textTween(`#PLAN_${col.name}_${this.localId}`, col.plan, 500, '%', null, null, null, null, 1)
        this.gmx_textTween(`#DELTA_${col.name}_${this.localId}`, col.delta, 500, '%', null, null, null, null, 1)
      })

    }

  } 
}